import { useContext } from "react";

import { Alternative } from "src/helpers/types";
import existing1 from "./images/map/exampleTrip1/existing.jpg";
import existing2 from "./images/map/exampleTrip2/existing.jpg";
import NB_Only1 from "./images/map/exampleTrip1/NB_Only.jpg";
import NB_Only2 from "./images/map/exampleTrip2/NB_Only.jpg";
import SB_Only1 from "./images/map/exampleTrip1/SB_Only.jpg";
import SB_Only2 from "./images/map/exampleTrip2/SB_Only.jpg";
import Converging_Diverging1 from "./images/map/exampleTrip1/Converging_Diverging.jpg";
import Converging_Diverging2 from "./images/map/exampleTrip2/Converging_Diverging.jpg";
import Converging_Diverging_Short1 from "./images/map/exampleTrip1/Converging_Diverging_Short.jpg";
import Converging_Diverging_Short2 from "./images/map/exampleTrip2/Converging_Diverging_Short.jpg";
import { LanguageContext } from "../languageContext";
import { cn } from "src/lib/utils";
import { TextId } from "src/Translations";

const imageMapper: Record<string, Record<Alternative, string>> = {
  exampleTrip1: {
    existing: existing1,
    NB_Only: NB_Only1,
    SB_Only: SB_Only1,
    Converging_Diverging: Converging_Diverging1,
    Converging_Diverging_Short: Converging_Diverging_Short1,
  },
  exampleTrip2: {
    existing: existing2,
    NB_Only: NB_Only2,
    SB_Only: SB_Only2,
    Converging_Diverging: Converging_Diverging2,
    Converging_Diverging_Short: Converging_Diverging_Short2,
  },
};

export default function ExampleTripMap({
  alternative,
  endMarkerClassName,
  startMarkerClassName,
  tripId,
}: {
  alternative: Alternative;
  endMarkerClassName?: string;
  startMarkerClassName?: string;
  tripId: string;
}) {
  const { translate } = useContext(LanguageContext);
  const image = imageMapper[tripId][alternative];

  if (!image) {
    throw new Error(`No image found for ${tripId} ${alternative}`);
  }

  return (
    <div className="h-[500px] flex flex-col justify-center items-center overflow-clip relative">
      <img
        src={image}
        alt={translate(`${tripId}-${alternative}` as TextId)}
        className="h-full w-full max-w-[432px] object-cover object-center"
      />
      <div
        className={cn(
          "absolute flex justify-center items-center w-[80px] h-[50px] bg-white rounded-full border-2 border-black",
          startMarkerClassName
        )}
      >
        {translate("mapStartMarker")}
      </div>
      <div
        className={cn(
          "absolute flex justify-center items-center w-[80px] h-[50px] bg-white rounded-full border-2 border-black",
          endMarkerClassName
        )}
      >
        {translate("mapEndMarker")}
      </div>
    </div>
  );
}
